var _rect, _rect2, _rect3, _line, _line2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 14,
    height: 14,
    rx: 2,
    ry: 2,
    stroke: "#66C15E",
    strokeWidth: 1.5,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#66C15E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#66C15E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 9,
    x2: 15.5,
    y2: 9,
    stroke: "#66C15E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    opacity: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 12.5,
    x2: 15.5,
    y2: 12.5,
    stroke: "#66C15E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    opacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 17,
    r: 4,
    fill: "#66C15E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 16.1L18.6 17.6L20.8 15.4",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.243a8c3783e97a5e524d71cd6795af42.svg";
export { ForwardRef as ReactComponent };